<template>
  <div class="h-100" style="min-height: 1px">
    <div v-bar class="bar-out">
      <div>
        <div
          v-if="!$store.state.customer.current.meta.energetics.length"
          class="text-center my-3"
        >
          <div class="mb-3">
            <b-icon font-scale="5" icon="question-diamond" />
          </div>
          <h2 class="mb-3">Žiadne dáta</h2>
          <b-dropdown
            v-if="$root.user.isAdmin"
            right
            size="lg"
            variant="primary"
          >
            <template slot="button-content">
              <b-icon class="mr-1" icon="plus" scale="1.5x" />
              <span class="text-uppercase">Pridať odberné miesto</span>
            </template>
            <b-dropdown-item-button
              @click="openAddEnergeticModal({ type: 'power' })"
            >
              <icon class="text-power icon-fw mr-2" name="plug" scale="0.75" />
              Elektrina
            </b-dropdown-item-button>
            <b-dropdown-item-button
              @click="openAddEnergeticModal({ type: 'gas' })"
            >
              <icon class="text-gas icon-fw mr-2" name="fire" scale="0.75" />
              Plyn
            </b-dropdown-item-button>
            <b-dropdown-item-button
              @click="openAddEnergeticModal({ type: 'water' })"
            >
              <icon class="text-water icon-fw mr-2" name="tint" scale="0.75" />
              Voda
            </b-dropdown-item-button>
            <b-dropdown-item-button
              @click="openAddEnergeticModal({ type: 'heat' })"
            >
              <icon class="text-heat icon-fw mr-2" name="sun" scale="0.75" />
              Teplo
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
        <template v-else>
          <div class="d-flex flex-column h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex flex-shrink-1">
                <select-picker
                  v-model="energetics_id"
                  :label="[
                    'powerNumber',
                    'gasNumber',
                    'waterNumber',
                    'heatNumber',
                  ]"
                  btn-class="m-0 font-weight-bold"
                  btn-variant="white"
                  :fetch-url="`customers/${$route.params.id}/get_energetics`"
                  placeholder="Vyberte odberné miesto"
                  @loaded="energeticsLoading = false"
                >
                  <template #option="props">
                    <div
                      :class="`text-${props.option._type.const.toLowerCase()}`"
                      class="font-weight-bold"
                    >
                      <icon
                        :name="
                          $store.getters['energetic/getTypeByID'](
                            props.option.typeID,
                          ).icon
                        "
                        class="icon-fw"
                        scale="0.75"
                      />
                      {{
                        props.option.powerNumber ||
                        props.option.gasNumber ||
                        props.option.waterNumber ||
                        props.option.heatNumber
                      }}
                    </div>
                    <div
                      v-if="props.option.localityName"
                      class="text-muted fs-sm"
                    >
                      {{ props.option.localityName }}
                    </div>
                  </template>
                </select-picker>
                <b-dropdown
                  v-if="$root.user.isAdmin"
                  class="ml-2"
                  menu-class="dropdown-menu-animated"
                  variant="primary"
                >
                  <template #button-content>
                    <b-icon icon="plus" scale="1.5x" />
                  </template>
                  <b-dropdown-item
                    @click="openAddEnergeticModal({ type: 'power' })"
                  >
                    <icon
                      class="text-power icon-fw mr-2"
                      name="plug"
                      scale="0.75"
                    />
                    Elektrina
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="openAddEnergeticModal({ type: 'gas' })"
                  >
                    <icon
                      class="text-gas icon-fw mr-2"
                      name="fire"
                      scale="0.75"
                    />
                    Plyn
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="openAddEnergeticModal({ type: 'water' })"
                  >
                    <icon
                      class="text-water icon-fw mr-2"
                      name="tint"
                      scale="0.75"
                    />
                    Voda
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="openAddEnergeticModal({ type: 'heat' })"
                  >
                    <icon
                      class="text-heat icon-fw mr-2"
                      name="sun"
                      scale="0.75"
                    />
                    Teplo
                  </b-dropdown-item>
                </b-dropdown>
                <b-dropdown
                  v-if="$root.user.isAdmin"
                  class="ml-2"
                  variant="outline-secondary"
                >
                  <template #button-content>
                    <b-icon icon="three-dots" />
                  </template>
                  <b-dropdown-item-button
                    @click.prevent="
                      openAddEnergeticModal({
                        type: $refs.energeticIndex.type,
                        edit: true,
                      })
                    "
                  >
                    <b-icon icon="pencil-square" class="mr-1" />
                    Upraviť
                  </b-dropdown-item-button>
                  <b-dropdown-item-button
                    @click.prevent="openCopyEnergeticModal"
                  >
                    <b-icon icon="arrow-left-right" class="mr-1" />
                    Presunúť
                  </b-dropdown-item-button>
                  <b-dropdown-item-button
                    class="text-danger"
                    @click.prevent="remove"
                  >
                    <b-icon icon="trash" class="mr-1" />
                    Vymazať
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
              <div>
                <b-nav class="nav-sub">
                  <b-nav-item :to="{ name: 'customerEnergeticsDetail' }" exact>
                    <b-icon class="mr-1" icon="eye" />
                    Prehľad
                  </b-nav-item>
                  <b-nav-item :to="{ name: 'customerEnergeticTechnicalTab' }">
                    <b-icon class="mr-1" icon="wrench" />
                    Technické hodnoty
                  </b-nav-item>
                  <b-nav-item :to="{ name: 'customerEnergeticContractTab' }">
                    <b-icon class="mr-1" icon="vector-pen" />
                    Zmluvné hodnoty
                  </b-nav-item>
                  <b-nav-item
                    v-if="currentType === 'power'"
                    :to="{ name: 'customerEnergeticDeviceTab' }"
                  >
                    <b-icon class="mr-1" icon="hdd-network" />
                    Prístroje
                  </b-nav-item>
                  <b-nav-text class="mr-3"> | </b-nav-text>
                  <b-nav-item-dropdown
                    class="mr-1"
                    right
                    toggle-class="nav-link-custom"
                  >
                    <template #button-content>
                      <b-icon class="mr-1" icon="arrow-down-circle" />
                    </template>
                    <b-dropdown-item
                      v-if="$root.user.isAdmin && currentType === 'power'"
                      :to="{ name: 'customerEnergeticTimeTab' }"
                    >
                      <b-icon class="mr-1" icon="clock" />
                      Časy vyhodnotenia
                    </b-dropdown-item>
                    <b-dropdown-item @click="gotoReport('reportConsumer')">
                      <b-icon class="mr-1" icon="file-earmark-text" />
                      Fakturačné dáta
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="currentType === 'power' || currentType === 'gas'"
                      @click="gotoReport('reportPerformance')"
                    >
                      <b-icon class="mr-1" icon="graph-up" />
                      Výkonové dáta
                    </b-dropdown-item>
                  </b-nav-item-dropdown>
                </b-nav>
              </div>
            </div>
            <transition mode="out-in" name="fadeShort">
              <router-view
                v-if="!loading"
                ref="energeticIndex"
                :key="$route.params.energetics_id"
              />
            </transition>
          </div>
        </template>
      </div>
    </div>
    <add-energetic ref="energeticForm" />
    <copy-energetic ref="copyEnergeticForm" />
  </div>
</template>
<script>
import SelectPicker from '@/components/inputs/SelectPicker'
import AddEnergetic from '@/module/energetics/customer/Add'
import CopyEnergetic from '@/module/energetics/customer/Copy'
import { mapState } from 'vuex'

export default {
  components: {
    SelectPicker,
    AddEnergetic,
    CopyEnergetic,
  },
  data() {
    return {
      energetics_id: parseInt(this.$route.params.energetics_id),
      energeticsList: [],
      energeticsLoading: true,
    }
  },
  watch: {
    energetics_id(val) {
      this.$router.push({
        name: 'customerEnergeticsDetail',
        params: { energetics_id: val },
      })
      this.getCurrent()
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.energetic.current.loading,
      customer: (state) => state.customer.current.data,
    }),
    currentType() {
      return this.$store.getters['energetic/getCurrentType']
    },
    currentTypeId() {
      return this.$store.getters['energetic/getCurrentTypeId']
    },
  },
  created() {
    this.getCurrent()
  },
  mounted() {
    this.$root.$on('reloadCustomerEnergeticsData', this.getCurrent)
  },
  beforeDestroy() {
    this.$root.$off('reloadCustomerEnergeticsData')
  },
  methods: {
    getCurrent() {
      if (parseInt(this.$route.params.energetics_id)) {
        this.$store.dispatch('energetic/getCurrent', {
          id: this.$route.params.energetics_id,
          params: { with: 'contract;technical' },
        })

        this.$api
          .get(`customers/${this.$route.params.id}/get_energetics`)
          .then((res) => {
            this.energeticsList = res.data.data
          })
      }
    },
    energWithLoc({
      powerNumber,
      gasNumber,
      waterNumber,
      heatNumber,
      localityName,
    }) {
      return `${powerNumber || gasNumber || waterNumber || heatNumber} — ${localityName}`
    },
    openAddEnergeticModal({ type, edit = false }) {
      this.$refs.energeticForm.type = type
      this.$refs.energeticForm.edit = edit
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-energetic')
      })
    },
    openCopyEnergeticModal() {
      this.$refs.copyEnergeticForm.type =
        this.$store.getters['energetic/getCurrentType']
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'copy-energetic')
      })
    },
    remove() {
      this.$swal({
        title: 'Ste si istý?',
        html: 'Skutočne chcete odstrániť toto odberné miesto?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api
            .post(`energetics/${this.$route.params.energetics_id}/delete`)
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              })
              this.$router.push({
                name: 'customerView',
                params: { id: this.$route.params.id },
              })
              this.$nextTick(() => {
                this.$root.$emit('reloadCustomerData')
              })
            })
        }
      })
    },
    gotoReport(name) {
      this.$router.push({
        name: name,
        params: { id: this.$route.params.energetics_id },
      })
      this.$store.dispatch('report/setFilter', {
        type: this.currentTypeId,
        customer: this.customer?.name,
      })
    },
  },
}
</script>
